export default __webpack_public_path__ + "static/media/MaskGroup207.1e5a54e5.png";